import type { IWebsiteMode } from '@glocal/schemas'

/** Result of WizardService.Detect — see apps/api/src/wizard/detect.ts. */
export interface Detect {
	dns_provider: string
	apex_cname: 'supported' | 'unsupported' | 'unknown'
	hosting: string
	hidden_origin: 'not-needed' | 'available' | 'unknown'
	recommended_mode: IWebsiteMode
}

/**
 * What the wizard assumes when the detect errors or doesn't answer in time: we
 * know nothing, so nothing is ruled out and only the mode that works everywhere
 * is recommended. Compared by identity to tell "answered" from "gave up".
 */
export const UNKNOWN_DETECT: Detect = {
	dns_provider: 'unknown',
	apex_cname: 'unknown',
	hosting: 'unknown',
	hidden_origin: 'unknown',
	recommended_mode: 'subdomain',
}
